import React from 'react';
import Immutable from 'seamless-immutable';
import PropTypes from 'prop-types';
import {BlogDetail} from 'epic-react-blog/app/scripts/components';
import {connectToStores} from 'epic-alt-utils/index';
import {MotdStore, BlogStore} from '../../stores';

@connectToStores
export default class Motd extends React.PureComponent {
    static propTypes = {
        motdStore: PropTypes.object,
        blogStore: PropTypes.object
    };

    static getStores() {
        return [MotdStore, BlogStore];
    }

    static getPropsFromStores() {
        return {
            motdStore: MotdStore.getState(),
            blogStore: BlogStore.getState()
        };
    }

    render() {
        const {motdStore, blogStore} = this.props;
        const blog = motdStore.motdBlogPost;
        const blogList = [];
        const {locale} = blog;
        const slug = blog.title;
        const displayBlogDetailCategories = false;
        const enableContentToss = true;
        const enableLinkNavigator = false;
        const enableSocialMetrics = true;
        const isLauncher = false;
        let {config} = blogStore;
        config = config.set('shareOptions', {
            facebook: true,
            twitter: true,
            vk: true,
            google: true
        });
        return (
            <div>
                <BlogDetail
                    blog={Immutable(blog)}
                    blogList={Immutable(blogList)}
                    enableComments={false}
                    commentCount={0}
                    locale={locale}
                    slug={slug}
                    displayBlogDetailCategories={displayBlogDetailCategories}
                    enableContentToss={enableContentToss}
                    enableLinkNavigator={enableLinkNavigator}
                    enableSocialMetrics={enableSocialMetrics}
                    isLauncher={isLauncher}
                    config={config} />
            </div>
        );
    }
}
